import { TextField, Typography } from '@mui/material';
import { ChangeEvent, FC, useCallback } from 'react';

const ApiKeyNameTextField: FC<
  React.PropsWithChildren<ApiKeyNameTextFieldProps>
> = ({ apiKeyName, setApiKeyName }) => {
  const handleTokenNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setApiKeyName(value);
    },
    [setApiKeyName],
  );

  return (
    <div>
      <Typography mb={0.5} color='text.primary'>
        API Key Name
      </Typography>
      <TextField
        required
        type='text'
        fullWidth
        value={apiKeyName}
        onChange={handleTokenNameChange}
      />
    </div>
  );
};

export interface ApiKeyNameTextFieldProps {
  apiKeyName: string;
  setApiKeyName: (value: React.SetStateAction<string>) => void;
}

export default ApiKeyNameTextField;
